export default {
  timesheetData: [],
  profileImage: '/img/pipefishLogo.png',
}